// removed by extract-text-webpack-plugin
module.exports = {"Page":"_2pDmW17Yx_pVZF2D1rjSzK"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Timesheet/index.css
// module id = 873
// module chunks = 0